import {
  aboutSection,
  featuredTestimonialSection,
  finalCTASection,
  geotaggedProjectsSection,
  homeHeroSection,
  mapSection,
  offersSection,
  servicesSection,
  testimonialsSection,
} from "@/lib/constants/sections/individualSections";

const HOME_SECTIONS = [
  homeHeroSection,
  servicesSection,
  aboutSection,
  testimonialsSection,
  offersSection,
  geotaggedProjectsSection,
  mapSection,
  featuredTestimonialSection,
  finalCTASection,
];

export default HOME_SECTIONS.map((s, idx) => ({ ...s, order: idx + 1 }));
